import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '홈', path: '/' },
    { label: '솔루션', path: '/solution' },
    { label: '문의하기', path: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-100 border-b border-gray-200">
      <nav className="px-8 md:px-16 flex items-center justify-between h-24">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer shrink-0">
          <img
            src="https://static.readdy.ai/image/00aed269fb1e179199d0d5bf56fc46fa/c2bfb347a213c254cb30dae5f99299d3.png"
            alt="SG SMART GEO 로고"
            className="h-16 w-auto object-contain"
          />
        </Link>

        {/* Desktop Menu - centered */}
        <ul className="hidden md:flex items-center gap-14 absolute left-1/2 -translate-x-1/2">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-[22px] font-bold tracking-tight transition-colors duration-200 whitespace-nowrap relative pb-1 ${
                  isActive(link.path)
                    ? 'text-[#1B2A4A]'
                    : 'text-gray-600 hover:text-[#1B2A4A]'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#E8521A] rounded-full" />
                )}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <Link
          to="/contact"
          className="hidden md:inline-flex items-center gap-2 bg-[#E8521A] text-white font-bold text-[18px] px-8 py-4 rounded-full hover:bg-[#d04515] transition-all duration-200 whitespace-nowrap"
        >
          <span>문의하기</span>
          <i className="ri-arrow-right-line" />
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-12 h-12 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="메뉴 열기"
        >
          <i className={`text-2xl text-[#1B2A4A] ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-gray-100 border-t border-gray-200 overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-72 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <ul className="px-8 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`block text-[18px] font-bold py-1 transition-colors duration-200 whitespace-nowrap ${
                  isActive(link.path) ? 'text-[#E8521A]' : 'text-gray-700 hover:text-[#E8521A]'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#E8521A] text-white text-[17px] font-bold px-7 py-3.5 rounded-full whitespace-nowrap"
            >
              문의하기
              <i className="ri-arrow-right-line" />
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
